export default __webpack_public_path__ + "media/images/react_icons/close-icon-c443bfc1a8b863e4004edfad6be1a1b1.svg";